import { NativeEvent } from '../NativeEvent';

export interface SafeAreaColorsPayload {
  /** Cor de fundo do topo atual (header/barra do jogo), em CSS (rgb/hex). */
  top: string;
}

/**
 * Informa ao app nativo a cor do topo da tela atual, pra ele pintar a faixa
 * de safe-area (notch/Dynamic Island) combinando com a pagina/tema.
 */
export class SafeAreaColorsEvent extends NativeEvent<
  'safeAreaColors',
  SafeAreaColorsPayload
> {
  readonly type = 'safeAreaColors';
  readonly payload: SafeAreaColorsPayload;

  constructor(payload: SafeAreaColorsPayload) {
    super();
    this.payload = payload;
  }

  protected override validate(): void {
    if (!this.payload.top) {
      throw new Error('SafeAreaColorsEvent: top e obrigatorio');
    }
  }
}
